var map = {
	"./amber.png": "lJpE",
	"./amberui.png": "ih6U",
	"./base-1.png": "WCb6",
	"./base-2.png": "nMdp",
	"./base-3.png": "S/MQ",
	"./base-4.png": "PWqN",
	"./base-5.png": "/Ajj",
	"./brobnar.png": "qs3W",
	"./capture.png": "OzAM",
	"./captureui.png": "RlsD",
	"./damage.png": "zCYG",
	"./damageui.png": "2qIU",
	"./dis.png": "ojIs",
	"./discard.png": "yxN/",
	"./discardui.png": "Zrg+",
	"./draw.png": "1+I9",
	"./drawui.png": "SpXk",
	"./ekwidon.png": "gTJP",
	"./geistoid.png": "4ohK",
	"./logos.png": "DDk4",
	"./mars.png": "hutY",
	"./redemption.png": "8ay2",
	"./sanctum.png": "j6Em",
	"./saurian.png": "bKiA",
	"./shadows.png": "TsoV",
	"./skyborn.png": "OIVk",
	"./staralliance.png": "k3sz",
	"./unfathomable.png": "gM9W",
	"./untamed.png": "g6T7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WZmR";